export enum CountryIso3Code {
  GreatBritain = 'GBR',
  Ireland = 'IRL',
}
